import React from 'react';
import { Mail, Lock, Shield, Folder, Users, ClipboardList, Heart, Leaf, AlertTriangle, MessageSquare, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComingSoonMockupPage() {
  return <div className="min-h-screen bg-[#fdfbf7] text-[#1e3a3a] font-sans selection:bg-[#1e3a3a] selection:text-white" data-id="element-1205">
      <style data-id="element-1206">{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&display=swap');
        .font-fraunces {
          font-family: 'Fraunces', serif;
        }
      `}</style>

      {/* Header */}
      <header className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between" data-id="element-1207">
        <Link to="/" className="text-3xl font-fraunces font-semibold tracking-tight text-[#1e3a3a]" data-id="element-1208">
          Caveo
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#1e3a3a]" data-id="element-1209">
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1210">
            How it Works
          </a>
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1211">
            Our Pledges
          </a>
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1212">
            Crisis Help
          </a>
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1213">
            About Us
          </a>
        </nav>
        <button className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#1e3a3a] text-sm font-medium hover:bg-[#1e3a3a] hover:text-white transition-colors" data-id="element-1214">
          <Mail size={16} data-id="element-1215" />
          Join Waitlist
        </button>
      </header>

      <main className="max-w-7xl mx-auto px-6 pb-24 space-y-8" data-id="element-1216">
        {/* Hero Section */}
        <section className="py-12 md:py-20 flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-1217">
          <div className="flex-1 max-w-2xl" data-id="element-1218">
            <h1 className="text-5xl md:text-6xl font-fraunces font-medium leading-[1.1] tracking-tight mb-8 text-[#1e3a3a]" data-id="element-1219">
              Guided digital protection for the people you love.
            </h1>
            <div className="w-16 h-[1px] bg-[#d2c5b8] mb-8" data-id="element-1220"></div>
            <p className="text-lg text-[#3a4f4f] mb-10 leading-relaxed max-w-xl" data-id="element-1221">
              Caveo helps families and adult children secure what matters
              most—accounts, devices, and important information.
            </p>
            <button className="flex items-center gap-2 bg-[#1e3a3a] text-white px-8 py-4 rounded-full font-medium hover:bg-[#152a2a] transition-colors shadow-sm mb-6" data-id="element-1222">
              <Lock size={18} data-id="element-1223" />
              Join the Early Access List
              <ChevronRight size={18} className="ml-1" data-id="element-1224" />
            </button>
            <div className="flex items-center gap-2 text-sm text-[#5a6f6f]" data-id="element-1225">
              <Shield size={16} className="text-[#1e3a3a]" data-id="element-1226" />
              Private by design. Built for real life. Here when you need us.
            </div>
          </div>

          <div className="flex-1 relative w-full max-w-xl lg:max-w-none" data-id="element-1227">
            {/* Placeholder for the illustration */}
            <div className="aspect-[4/3] rounded-2xl bg-[#e6ebe6] overflow-hidden relative shadow-inner border border-[#dce3de]" data-id="element-1228">
              <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=2070&auto=format&fit=crop" alt="Family looking at view" className="w-full h-full object-cover opacity-60 mix-blend-multiply" data-id="element-1229" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#e6ebe6] to-transparent opacity-50" data-id="element-1230"></div>
            </div>

            {/* Floating Cards */}
            <div className="absolute -right-4 top-12 space-y-4 hidden md:block" data-id="element-1231">
              <div className="bg-white p-4 rounded-xl shadow-lg border border-[#f0f0f0] flex items-start gap-4 w-64 transform transition-transform hover:-translate-y-1" data-id="element-1232">
                <div className="w-10 h-10 rounded-full border border-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1233">
                  <Shield size={20} className="text-[#1e3a3a]" data-id="element-1234" />
                </div>
                <div data-id="element-1235">
                  <h4 className="font-medium text-[#1e3a3a] text-sm mb-0.5" data-id="element-1236">
                    Secure
                  </h4>
                  <p className="text-xs text-[#5a6f6f] leading-tight" data-id="element-1237">
                    Strong protection for everyday life.
                  </p>
                </div>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-lg border border-[#f0f0f0] flex items-start gap-4 w-64 transform transition-transform hover:-translate-y-1 ml-4" data-id="element-1238">
                <div className="w-10 h-10 rounded-full border border-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1239">
                  <Folder size={20} className="text-[#1e3a3a]" data-id="element-1240" />
                </div>
                <div data-id="element-1241">
                  <h4 className="font-medium text-[#1e3a3a] text-sm mb-0.5" data-id="element-1242">
                    Organized
                  </h4>
                  <p className="text-xs text-[#5a6f6f] leading-tight" data-id="element-1243">
                    All your important info in one place.
                  </p>
                </div>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-lg border border-[#f0f0f0] flex items-start gap-4 w-64 transform transition-transform hover:-translate-y-1 ml-8" data-id="element-1244">
                <div className="w-10 h-10 rounded-full border border-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1245">
                  <Users size={20} className="text-[#1e3a3a]" data-id="element-1246" />
                </div>
                <div data-id="element-1247">
                  <h4 className="font-medium text-[#1e3a3a] text-sm mb-0.5" data-id="element-1248">
                    Shared
                  </h4>
                  <p className="text-xs text-[#5a6f6f] leading-tight" data-id="element-1249">
                    So the right people can help—when needed.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How it works */}
        <section className="bg-[#fcfaf8] rounded-3xl p-10 md:p-12 border border-[#f0eae1] shadow-sm" data-id="element-1250">
          <h2 className="text-3xl font-fraunces font-medium text-center mb-12 text-[#1e3a3a]" data-id="element-1251">
            How it works in 3 steps
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-1252">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[1px] bg-[#e0d8ce] -z-10" data-id="element-1253"></div>

            <div className="flex flex-col items-center text-center" data-id="element-1254">
              <div className="relative mb-6" data-id="element-1255">
                <div className="w-24 h-24 rounded-full bg-[#e6ebe6] flex items-center justify-center" data-id="element-1256">
                  <ClipboardList size={32} className="text-[#1e3a3a]" data-id="element-1257" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#1e3a3a] text-white flex items-center justify-center text-sm font-medium border-4 border-[#fcfaf8]" data-id="element-1258">
                  1
                </div>
              </div>
              <h3 className="text-lg font-medium text-[#1e3a3a] mb-3" data-id="element-1259">
                We guide you
              </h3>
              <p className="text-sm text-[#5a6f6f] leading-relaxed max-w-xs" data-id="element-1260">
                Answer simple questions. We'll help you get organized without
                the overwhelm.
              </p>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-1261">
              <div className="relative mb-6" data-id="element-1262">
                <div className="w-24 h-24 rounded-full bg-[#e6ebe6] flex items-center justify-center" data-id="element-1263">
                  <Lock size={32} className="text-[#1e3a3a]" data-id="element-1264" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#1e3a3a] text-white flex items-center justify-center text-sm font-medium border-4 border-[#fcfaf8]" data-id="element-1265">
                  2
                </div>
              </div>
              <h3 className="text-lg font-medium text-[#1e3a3a] mb-3" data-id="element-1266">
                We help you protect
              </h3>
              <p className="text-sm text-[#5a6f6f] leading-relaxed max-w-xs" data-id="element-1267">
                We secure your accounts, devices, and documents with clear,
                expert guidance.
              </p>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-1268">
              <div className="relative mb-6" data-id="element-1269">
                <div className="w-24 h-24 rounded-full bg-[#e6ebe6] flex items-center justify-center" data-id="element-1270">
                  <Users size={32} className="text-[#1e3a3a]" data-id="element-1271" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#1e3a3a] text-white flex items-center justify-center text-sm font-medium border-4 border-[#fcfaf8]" data-id="element-1272">
                  3
                </div>
              </div>
              <h3 className="text-lg font-medium text-[#1e3a3a] mb-3" data-id="element-1273">
                You're never alone
              </h3>
              <p className="text-sm text-[#5a6f6f] leading-relaxed max-w-xs" data-id="element-1274">
                Share access with trusted people and know help is here if
                something happens.
              </p>
            </div>
          </div>
        </section>

        {/* Two Column Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1275">
          {/* Pledges */}
          <section className="bg-[#f2f4f2] rounded-3xl p-10 border border-[#e6ebe6] flex flex-col" data-id="element-1276">
            <h2 className="text-2xl font-fraunces font-medium text-center mb-10 text-[#1e3a3a]" data-id="element-1277">
              Our pledges to you
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10 flex-1" data-id="element-1278">
              <div className="flex flex-col items-center text-center" data-id="element-1279">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1280">
                  <Shield size={24} className="text-[#1e3a3a]" data-id="element-1281" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1282">
                  Privacy first
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1283">
                  Your data stays private and under your control.
                </p>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-1284">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1285">
                  <Heart size={24} className="text-[#1e3a3a]" data-id="element-1286" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1287">
                  Human-first support
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1288">
                  Real people, real guidance, when you need it.
                </p>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-1289">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1290">
                  <Lock size={24} className="text-[#1e3a3a]" data-id="element-1291" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1292">
                  Bank-grade security
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1293">
                  We use industry-leading security practices.
                </p>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-1294">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1295">
                  <Leaf size={24} className="text-[#1e3a3a]" data-id="element-1296" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1297">
                  Built for families
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1298">
                  Thoughtful by design. Peace of mind by default.
                </p>
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-[#3a4f4f] pt-6 border-t border-[#dce3de]" data-id="element-1299">
              <Lock size={16} data-id="element-1300" />
              We will never sell your data. Ever.
            </div>
          </section>

          {/* Crisis */}
          <section className="bg-[#f7efe8] rounded-3xl p-10 border border-[#f0e2d5] flex flex-col items-center text-center" data-id="element-1301">
            <h2 className="text-2xl font-fraunces font-medium mb-2 text-[#1e3a3a]" data-id="element-1302">
              Something just happened?
            </h2>
            <p className="text-[#5a6f6f] mb-10" data-id="element-1303">
              If you've been hacked, scammed, or locked out—start here.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10 w-full" data-id="element-1304">
              <div className="flex flex-col items-center" data-id="element-1305">
                <AlertTriangle size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1306" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1307">
                  Get calm
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1308">
                  Take a breath.
                  <br data-id="element-1309" />
                  We'll help.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-1310">
                <Lock size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1311" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1312">
                  Secure first
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1313">
                  Quick steps to lock
                  <br data-id="element-1314" />
                  things down.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-1315">
                <MessageSquare size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1316" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1317">
                  Get guidance
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1318">
                  Clear next steps
                  <br data-id="element-1319" />
                  from our team.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-1320">
                <Users size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1321" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1322">
                  You're not alone
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1323">
                  We're here with you
                  <br data-id="element-1324" />
                  the whole way.
                </p>
              </div>
            </div>
            <button className="flex items-center gap-2 px-6 py-3 rounded-full border border-[#1e3a3a] text-[#1e3a3a] font-medium hover:bg-[#1e3a3a] hover:text-white transition-colors mt-auto" data-id="element-1325">
              Go to Crisis Help
              <ChevronRight size={18} data-id="element-1326" />
            </button>
          </section>
        </div>

        {/* Bottom CTA */}
        <section className="bg-[#e6ebe6] rounded-3xl p-8 md:p-12 border border-[#dce3de] flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1327">
          <div className="flex items-center gap-6" data-id="element-1328">
            <div className="w-16 h-16 rounded-full bg-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1329">
              <Mail size={28} className="text-white" data-id="element-1330" />
            </div>
            <div data-id="element-1331">
              <h2 className="text-2xl font-fraunces font-medium text-[#1e3a3a] mb-1" data-id="element-1332">
                Be the first to know.
              </h2>
              <p className="text-[#5a6f6f]" data-id="element-1333">
                Join the waitlist for early access.
              </p>
            </div>
          </div>
          <div className="w-full md:w-auto flex-1 max-w-md" data-id="element-1334">
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-1335">
              <input type="email" placeholder="Enter your email address" className="flex-1 px-5 py-4 rounded-full border border-[#dce3de] focus:outline-none focus:border-[#1e3a3a] focus:ring-1 focus:ring-[#1e3a3a]" data-id="element-1336" />
              <button className="bg-[#1e3a3a] text-white px-8 py-4 rounded-full font-medium hover:bg-[#152a2a] transition-colors flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-1337">
                Join Waitlist
                <ChevronRight size={18} data-id="element-1338" />
              </button>
            </div>
            <div className="flex items-center gap-2 text-xs text-[#5a6f6f] mt-4 ml-2" data-id="element-1339">
              <Lock size={14} data-id="element-1340" />
              No spam. Just helpful updates and a heads-up when we launch.
            </div>
          </div>
        </section>
      </main>
    </div>;
}